const airglossIcons = {
  'menu-new': '\uea06',
  'menu-new-dot': '\uea07',
  'menu-3': '\uea04',
  'menu-dot': '\uea05',
  'menu-2': '\uea03',
  'night': '\ue9fe',
  'ozone': '\ue9ff',
  'shutter': '\uea00',
  'dataformat': '\uea01',
  'manual': '\uea02',
  'bluetooth': '\ue9fb',
  'clean': '\ue9fc',
  'temp-shift': '\ue9fd',
  'wifi-none': '\ue9e5',
  'ar-ur': '\ue9e6',
  'ar-lr': '\ue9e7',
  'ar-d': '\ue9e8',
  'ar-u': '\ue9e9',
  'ar-l': '\ue9ea',
  'ar-r': '\ue9eb',
  'ar-dl': '\ue9ec',
  'ar-dr': '\ue9f9',
  'ar-ul': '\ue9fa',
  'dice': '\ue9e3',
  'prize': '\ue9e4',
  'brush': '\ue9ed',
  'picker': '\ue9ee',
  'cone': '\ue9ef',
  'dots-horizontal': '\ue9f0',
  'dots-vertical': '\ue9f3',
  'drink': '\ue9f1',
  'circle-mid': '\ue9f2',
  'browser': '\ue9f4',
  'circle-small': '\ue9f5',
  'call-emergency': '\ue9f6',
  'refresh-3': '\ue9f7',
  'retweet': '\ue9f8',
  'eyecross': '\ue9e2',
  'alarm': '\ue9e1',
  'circle': '\ue9e0',
  'heatcool': '\ue9de',
  'snowflake': '\ue9df',
  'bell': '\ue9dd',
  'airplane': '\ue900',
  'anchor': '\ue901',
  'anchor-point': '\ue902',
  'archive': '\ue903',
  'bag': '\ue904',
  'balloon-chat-2': '\ue905',
  'balloon-text': '\ue906',
  'book': '\ue907',
  'call': '\ue908',
  'call-incoming': '\ue909',
  'call-outgoing': '\ue90a',
  'cart-empty': '\ue90b',
  'cart-full': '\ue90c',
  'cd': '\ue90d',
  'chart-pie': '\ue90e',
  'coffee': '\ue90f',
  'compass': '\ue910',
  'contract': '\ue911',
  'credit': '\ue912',
  'cut': '\ue913',
  'degree': '\ue914',
  'device-desktop': '\ue915',
  'device-mobile': '\ue916',
  'device-mouse': '\ue917',
  'device-tablet': '\ue918',
  'diamond': '\ue919',
  'edit': '\ue91a',
  'envelope': '\ue91b',
  'envelope-full': '\ue91c',
  'envelope-open': '\ue91d',
  'exchange': '\ue91e',
  'expand': '\ue91f',
  'file': '\ue920',
  'files': '\ue921',
  'film': '\ue922',
  'fire': '\ue923',
  'flash': '\ue924',
  'forward': '\ue925',
  'games': '\ue926',
  'ghost': '\ue927',
  'gift': '\ue928',
  'glasses': '\ue929',
  'globe': '\ue92a',
  'globe-2': '\ue92b',
  'gps': '\ue92c',
  'headphones': '\ue92d',
  'headphones-2': '\ue92e',
  'help': '\ue92f',
  'hourglass': '\ue930',
  'humi': '\ue931',
  'layers': '\ue932',
  'lock': '\ue933',
  'logo-dribbble': '\ue934',
  'logo-dropbox': '\ue935',
  'logo-fb': '\ue936',
  'logo-tumblr': '\ue937',
  'logo-tw': '\ue938',
  'logo-yt': '\ue939',
  'magic-wand': '\ue93a',
  'magnet': '\ue93b',
  'map': '\ue93c',
  'math': '\ue93d',
  'medal': '\ue93e',
  'microphone': '\ue93f',
  'moustache': '\ue940',
  'move': '\ue941',
  'music': '\ue942',
  'music-list': '\ue943',
  'music-notes': '\ue944',
  'notes': '\ue945',
  'open': '\ue946',
  'pencil': '\ue947',
  'picture': '\ue948',
  'picture-add': '\ue949',
  'pin': '\ue94a',
  'press': '\ue94b',
  'print': '\ue94c',
  'purse': '\ue94d',
  'puzzle': '\ue94e',
  'reply': '\ue94f',
  'science': '\ue950',
  'share': '\ue951',
  'shield': '\ue952',
  'sign': '\ue953',
  'signs': '\ue954',
  'smile': '\ue955',
  'tag': '\ue956',
  'temp': '\ue957',
  'trash': '\ue958',
  'trophy': '\ue959',
  'unlock': '\ue95a',
  'user-add': '\ue95b',
  'user-check': '\ue95c',
  'user-cross': '\ue95d',
  'user-female': '\ue95e',
  'user-group': '\ue95f',
  'user-male': '\ue960',
  'wallet': '\ue961',
  'wifi': '\ue962',
  'wrench': '\ue963',
  'balloon-chat': '\ue964',
  'balloon-writing': '\ue965',
  'voc': '\ue966',
  'iaq': '\ue967',
  'cross': '\ue968',
  'minus': '\ue969',
  'plus': '\ue96a',
  'check': '\ue96b',
  'sound': '\ue96c',
  'leaf': '\ue96d',
  'target-2': '\ue96e',
  'download': '\ue96f',
  'upload': '\ue970',
  'triangle-down': '\ue971',
  'triangle-left': '\ue972',
  'triangle-right': '\ue973',
  'triangle-up': '\ue974',
  'right': '\ue975',
  'up': '\ue976',
  'up-down': '\ue977',
  'down': '\ue978',
  'left': '\ue979',
  'meteo-1': '\ue97a',
  'meteo-2': '\ue97b',
  'meteo-3': '\ue97c',
  'meteo-4': '\ue97d',
  'meteo-5': '\ue97e',
  'meteo-6': '\ue97f',
  'meteo-7': '\ue980',
  'meteo-8': '\ue981',
  'meteo-9': '\ue982',
  'meteo-10': '\ue983',
  'meteo-11': '\ue984',
  'meteo-12': '\ue985',
  'meteo-13': '\ue986',
  'volume': '\ue987',
  'volume-no': '\ue988',
  'volume-up': '\ue989',
  'circle-question': '\ue98a',
  'clock': '\ue98b',
  'cloud-download': '\ue98c',
  'cloud-upload': '\ue98d',
  'deny': '\ue98e',
  'logout': '\ue98f',
  'circle-check': '\ue990',
  'circle-cross': '\ue991',
  'circle-down': '\ue992',
  'circle-info': '\ue993',
  'circle-left': '\ue994',
  'circle-minus': '\ue995',
  'circle-plus': '\ue996',
  'circle-right': '\ue997',
  'circle-up': '\ue998',
  'refresh-2': '\ue999',
  'gender-f': '\ue99a',
  'gender-m': '\ue99b',
  'circle-warning': '\ue99c',
  'link': '\ue99d',
  'key': '\ue99e',
  'search': '\ue99f',
  'zoom-in': '\ue9a0',
  'zoom-out': '\ue9a1',
  'attach': '\ue9a2',
  'flag': '\ue9a3',
  'eye': '\ue9a4',
  'paper-plane': '\ue9a5',
  'briefcase': '\ue9a6',
  'm-backward': '\ue9a7',
  'm-back': '\ue9a8',
  'm-pause': '\ue9a9',
  'm-play': '\ue9aa',
  'm-next': '\ue9ab',
  'm-forward': '\ue9ac',
  'star': '\ue9ad',
  'balloon': '\ue9ae',
  'camera': '\ue9af',
  'video': '\ue9b0',
  'heart': '\ue9b1',
  'folder': '\ue9b2',
  'light': '\ue9b3',
  'thumbs-up': '\ue9b4',
  'thumbs-down': '\ue9b5',
  'rocket': '\ue9b6',
  'cursor': '\ue9b7',
  'chart-bars': '\ue9b8',
  'umbrella': '\ue9b9',
  'calendar': '\ue9ba',
  'target': '\ue9bb',
  'chart': '\ue9bc',
  'grid': '\ue9bd',
  'repeat': '\ue9be',
  'filter': '\ue9bf',
  'home': '\ue9c0',
  'list': '\ue9c1',
  'menu': '\ue9c2',
  'inbox': '\ue9c3',
  'outbox': '\ue9c4',
  'speed': '\ue9c5',
  'ticket': '\ue9c6',
  'warning': '\ue9c7',
  'settings': '\ue9c8',
  'info-tech': '\ue9c9',
  'no2': '\ue9ca',
  'offline': '\ue9cb',
  'rgb': '\ue9cc',
  'fan-0': '\ue9cd',
  'fan-1': '\ue9ce',
  'fan-2': '\ue9cf',
  'fan-3': '\ue9d0',
  'fan-4': '\ue9d1',
  'fan-a': '\ue9d2',
  'co2': '\ue9d3',
  'connect': '\ue9d4',
  'disconnect': '\ue9d5',
  'fan': '\ue9d6',
  'clock-watch': '\ue9d7',
  'co': '\ue9d8',
  'ch4': '\ue9d9',
  'circle-average': '\ue9da',
  'ag-ck': '\ue9db',
  'ag_ps': '\ue9dc',
  'caret-down': '\uf0d7',
  'caret-up': '\uf0d8',
  'caret-left': '\uf0d9',
  'caret-right': '\uf0da',
  'sort': '\uf0dc',
  'unsorted': '\uf0dc',
  'sort-desc': '\uf0dd',
  'sort-down': '\uf0dd',
  'sort-asc': '\uf0de',
  'sort-up': '\uf0de',
  'angle-double-left': '\uf100',
  'angle-double-right': '\uf101',
  'angle-double-up': '\uf102',
  'angle-double-down': '\uf103',
  'angle-left': '\uf104',
  'angle-right': '\uf105',
  'angle-up': '\uf106',
  'angle-down': '\uf107',
  'ellipsis-h': '\uf141',
  'ellipsis-v': '\uf142',
  'battery': '\uf240',
  'battery-4': '\uf240',
  'battery-full': '\uf240',
  'battery-3': '\uf241',
  'battery-three-quarters': '\uf241',
  'battery-2': '\uf242',
  'battery-half': '\uf242',
  'battery-1': '\uf243',
  'battery-quarter': '\uf243',
  'battery-0': '\uf244',
  'battery-empty': '\uf244'
}

export default airglossIcons
